import { Delete, Edit } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'
import { DownloadKML } from '@/icons'

import { useActions } from '../hooks/useActions'
import { useGoBack } from '../hooks/useGoBack'
import { useTexts } from '../hooks/useTexts'
import { useDeleteTrafficAreaModal } from './../../../../../../../../modals/DeleteTrafficAreaModal'

interface Props {
  trafficArea: uui.domain.client.rm.TrafficRegion
}

export function Header(props: Props) {
  const { trafficArea } = props
  const { id: areaId } = trafficArea

  const { Modal: DeleteTrafficAreaModal } = useDeleteTrafficAreaModal()
  const actions = useActions(trafficArea)
  const goBack = useGoBack()
  const texts = useTexts()

  return (
    <>
      <preview.Header
        title={texts.title(trafficArea.name)}
        onClose={goBack}
        testId="traffic-area-view-header"
      >
        <preview.ActionBar>
          <preview.ActionBarItem
            icon={<Edit />}
            onClick={actions.onEdit}
            label={texts.edit}
            tooltip={texts.edit}
            testId="setup-region__edit"
            disableWhenReadOnly
          />
          <preview.ActionBarItem
            icon={<DownloadKML size={24} />}
            key="close"
            onClick={actions.onExport}
            label={texts.exportKML}
            tooltip={texts.exportKML}
            data-testid="setup-traffic__exportkml"
            disableWhenReadOnly={false}
          />
          <preview.ActionBarItem
            icon={<Delete />}
            key="close"
            onClick={actions.onDelete}
            label={texts.delete}
            tooltip={texts.delete}
            disableWhenReadOnly
            data-testid="setup-traffic__delete"
          />
        </preview.ActionBar>
      </preview.Header>

      <DeleteTrafficAreaModal trafficAreas={[areaId]} />
    </>
  )
}
